<script>
import router from '../../index'
import { authMethods } from '@/state/helpers'

export default {
  methods: {
    ...authMethods
  },
  created() {
    // Perform Firebase logout
    if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
      // Remove Firebase token from localStorage
      localStorage.removeItem('token')

      this.logOut()
        .then(() => {
          console.log('Firebase logout successful')
          router.push('/login')
        })
        .catch(error => {
          console.error('Firebase logout error:', error)
          router.push('/login')
        })
    } else {
      router.push('/login')
    }
  }
}
</script>
